<template>
  <div
    class="promo-banner"
    :class="`promo-banner--${theme}`"
  >
    <span
      id="promo-banner-title"
      class="visually-hidden"
      v-text="$string('general.site_header.promo_banner')"
    />

    <div class="promo-banner__list">
      <component
        :is="settings.link ? 'a' : 'div'"
        :href="settings.link"
        class="promo-banner__list-item text-body-s-regular"
        v-text="settings.title"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Promo banner (promo-banner)
 * -----------------------------------------------------------------------------
 * Promo banner template.
 * - Conditionally loaded when section has blocks using Liquid.
 * - Scroll-snap is used for basic scrolling, you will need to add the carousel
 *   functionality if this is required.
 *
 * @param {Array} theme - Banner theme (can be light or dark).
 * @param {Array} settings - Section settings.
 *
 */
export default {
  name: 'PromoBanner',

  props: {
    theme: {
      type: String,
      default: 'light',
    },
    settings: {
      type: Object,
      default: () => ({
        title: '',
        link: '',
      }),
    },
  },
}
</script>

<style lang="scss">
@import './promo-banner';
</style>
